import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_job_status = _resolveComponent("job-status")!

  return (_openBlock(), _createBlock(_component_job_status, {
    "job-id": _ctx.jobId,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changed', $event)))
  }, {
    default: _withCtx(({ isLoading, success, failure }) => [
      failure
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            icon: "fa fa-exclamation",
            title: "An error occurred while executing the search.",
            color: "negative",
            round: "",
            flat: ""
          }))
        : (isLoading || !success)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              icon: "fa fa-spinner fa-spin",
              title: "Searching posts...",
              round: "",
              flat: ""
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["job-id", "model-value"]))
}